export default {
  "en": {
    backTitle: "Back",
    title: 'LinknLink Privacy Policy',
    contents: {
      title: 'LinknLink Privacy Policy',
      text: "",
      step: [{
        title: "Updated: June 5th, 2023  Effective date: June 5, 2023",
        tip: "",
      }, {
        title: "1 LinknLink PTY LTD and its affiliates (referred to as \"we\" or \"LinknLink\") are committed to protecting your personal privacy. This privacy policy (referred to as \"the policy\") explains how we handle personal data and protect information privacy when you use the following services, products, and related mobile applications (collectively referred to as \"products\").",
        tip: "",
      }, {
        title: "1.1 In this policy, \"personal data\" refers to personally identifiable information that can be used alone or in combination with other information. \"Smart devices\" refer to non-standard computing devices produced or manufactured by hardware manufacturers. These devices have a human-machine (interactive) interface and can transmit data through wireless networks, including smart home appliances, smart wearable devices, smart air purifiers, etc. \"Applications\" refer to a mobile application developed by LinknLink that allows end-users to remotely control smart devices and connect to LinknLink's Internet of Things (IoT) platform.",
        tip: "",
      }, {
        title: "1.2 For other brands' mobile applications supported by LinknLink, it is our customers who decide what personal data to collect through our products. We collect information according to customer requirements, and the handling of this information is limited to providing the services agreed upon with our customers. If you are our customer and you do not want to be contacted by us, please contact the brand directly and inform them of your request.",
        tip: "",
      }, {
        title: "1.3 To provide you with our services, we will ask you to provide the personal data required for such services. If you do not provide personal data, we will not be able to provide you with our products or services.",
        tip: "",
      }, {
        title: "2 Regarding the information you actively provide to us",
        tip: "",
      }, {
        title: "Account or profile data: When you register an account with us, we may collect your name and contact information, such as your email address, phone number, username, and login credentials. During your interaction with our products, we may further collect your nickname, avatar, country code, language preferences, or timezone information in your account, etc. Feedback: When you use the feedback and suggestion feature in our products, we will collect your voluntarily provided email address, phone number, and feedback content in order to promptly handle your issues and device failures.",
        tip: "",
      }, {
        title: "3 Regarding the information we automatically collect",
        tip: "",
      }, {
        title: "3.1 Account information: Your user nickname, avatar, phone number, and email address, Apple ID authorized login account name, Google authorized login account name, etc.",
        tip: "",
      }, {
        title: "3.2 Device information: When you interact with our products, we will automatically collect device information, such as location permission: When the device is connected to the network, Android 6.0 or above needs to obtain device Wi-Fi information (including nearby Wi-Fi list). MAC address, IP address, wireless connection information, operating system type and version, application version number, push notification identifier, log files, and mobile network information.",
        tip: "",
      }, {
        title: "3.3 Usage data: During your interaction with our websites and services, we automatically collect usage data related to access, clicks, downloads, sending/receiving messages, and other uses of our websites and services.",
        tip: "",
      }, {
        title: "3.4 Log information: When you use our applications, system and exception logs may be uploaded.",
        tip: "",
      }, {
        title: "3.5 Location information: When you use some of our products or services, we may collect real-time precise or imprecise geographic location information about you, such as weather services.",
        tip: "",
      }, {
        title: "3.6 Home name, home area (manually set by you), room information, home background image, local electricity price.",
        tip: "",
      }, {
        title: "3.7 Data usually generated when the user uses the function: scene information, linkage information, remote control panel information.",
        tip: "",
      }, {
        title: "3.8 Information about smart devices.",
        tip: "",
      }, {
        title: "3.8.1 Basic information of smart devices: When you use smart devices connected to our products or services, we may collect basic information about the smart device, such as device name, device ID, online status, activation time, firmware version, and upgrade information, etc.",
        tip: "",
      }, {
        title: "3.8.2 Information reported by smart devices: Depending on the different smart devices you choose to connect to our products or services, we may collect the information your smart devices report. For example, smart sensors may report temperature and humidity, human induction, lighting, etc.",
        tip: "",
      }, {
        title: "3.8.3 Media file information: After you authorize the storage data access permission, we will store the file name and file size of audio, video, and picture data according to your needs, and provide the media file for LinknLink application to play. (Currently only available in LinknLink application)",
        tip: "",
      }, {
        title: "3.9 We do not collect data about your personal race or ethnic origin, political views, religion, philosophy, union membership, personal genetic identification data, or data related to health, sexual life, or sexual orientation. We will not collect data from users under 16 without the permission of their guardians. If you are a child under 16, please obtain the permission of your parents or guardians before using our products and services.",
        tip: "",
      }, {
        title: "3.10 Explanation of third-party SDK access:",
        tip: "",
      }, {
        title: "3.10.1 Explanation of SDK access for third-party account login:",
        tip: "",
      }, {
        title: "①WeChat",
        collections: [{
          title: "Third-party entity: Shenzhen Tencent Technology Co., Ltd."
        }, {
          title: "Collected information: general device information, mac address, ip address"
        }, {
          title: "Purpose of use: to help users log in to LinknLink App through WeChat"
        }, {
          title: "Collection method: SDK collects directly from the machine"
        }, {
          title: "Third-party privacy policy link: https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy"
        }],
      }, {
        title: "②Apple",
        collections: [{
          title: "Third-party entity: Apple.Inc"
        }, {
          title: "Collected information: general device information, mac address, ip address"
        }, {
          title: "Purpose of use: to help users log in to Apple App"
        }, {
          title: "Collection method: SDK collects directly from the machine"
        }, {
          title: "Third-party privacy policy link: http://www.apple.com.cn/legal/privacy/szh/"
        }],
      }, {
        title: "③Google",
        collections: [{
          title: "Third-party entity: Google LLC"
        }, {
          title: "Collected information: general device information, mac address, ip address"
        }, {
          title: "Purpose of use: to help users log in to LinknLink App through Google"
        }, {
          title: "Collection method: SDK collects directly from the machine"
        }, {
          title: "Third-party privacy policy link: https://policies.google.cn/privacy?hl=zh-CN"
        }],
      }, {
        title: "3.10.2 Push notification SDK function access explanation:",
        tip: "",
      }, {
        title: "①Xiaomi",
        collections: [{
          title: "Third-party entity: Xiaomi Technology Co., Ltd."
        }, {
          title: "Collected information: user id, IMEI, device model, etc. general information"
        }, {
          title: "Purpose of use: to push messages to Xiaomi mobile phone users through LinknLink App"
        }, {
          title: "Collection method: SDK collects directly from the machine"
        }, {
          title: "Third-party privacy policy link: https://www.mi.com/aptitude/list?id=62"
        }],
      }, {
        title: "②Huawei",
        collections: [{
          title: "Third-party entity: Huawei Technology Co., Ltd."
        }, {
          title: "Collected information: user id, IMEI, device model, etc. general information"
        }, {
          title: "Purpose of use: LinknLink App is used to push messages to Huawei mobile phone users"
        }, {
          title: "Collection method: SDK collects directly from the machine"
        }, {
          title: "Third-party privacy policy link: https://www.huawei.com/cn/privacy-policy"
        }],
      }, {
        title: "③OPPO",
        collections: [{
          title: "Third-party entity: OPPO Guangdong Mobile Communications Co., Ltd."
        }, {
          title: "Collected information: general information such as user id, IMEI, device model, etc."
        }, {
          title: "Purpose of use: used to push messages to OPPO mobile phone users through the LinknLink App"
        }, {
          title: "Collection method: SDK collects directly from the machine"
        }, {
          title: "Third-party privacy policy link: https://privacy.oppo.com/cn/policy/"
        }],
      }, {
        title: "④VIVO",
        collections: [{
          title: "Third-party entity: Vivo Mobile Communications Co., Ltd."
        }, {
          title: "Collected information: general information such as user id, IMEI, device model, etc."
        }, {
          title: "Purpose of use: used by the LinknLink App to push messages to VIVO mobile phone users"
        }, {
          title: "Collection method: SDK collects directly from the machine"
        }, {
          title: "Third-party privacy policy link: http://www.vivo.com.cn/about-vivo/privacy-policy"
        }],
      }, {
        title: "⑤Meizu",
        collections: [{
          title: "Third-party entity:Meizu Technology Co., Ltd."
        }, {
          title: "Collected information: general information such as user id, IMEI, device model, etc."
        }, {
          title: "Purpose of use: used by the LinknLink App to push messages to Meizu mobile phone users"
        }, {
          title: "Collection method: SDK collects directly from the machine"
        }, {
          title: "Third-party privacy policy link: https://www.meizu.com/legal.html"
        }],
      }, {
        title: "3.10.3 App crash log report SDK access explanation:",
        tip: "",
      }, {
        title: "①Google firebase crashlytics",
        collections: [{
          title: "Third-party entity: Google LLC"
        }, {
          title: "Collected information: user id, crash log, device model, etc. general information"
        }, {
          title: "Purpose of use: to report LinknLink App crash log"
        }, {
          title: "Collection method: SDK collects directly from the machine"
        }, {
          title: "Third-party privacy policy link: https://policies.google.cn/privacy?hl=zh-CN"
        }],
      }, {
        title: "3.10.4 Gaode positioning SDK access explanation:",
        tip: "",
      }, {
        title: "①Gaode Positioning SDK",
        collections: [{
          title: "Third-party entity: Gaode Software Co., Ltd."
        }, {
          title: "Collected information: device information (IP address), device identification (IMEI), current application, device parameters, system information, and other general information, location (longitude and latitude)."
        }, {
          title: "Purpose of use: to provide location information for the home created on LinknLink App, and manage device location."
        }, {
          title: "Collection method: SDK collects directly from the machine."
        }, {
          title: "Third-party privacy policy link: https://lbs.amap.com/pages/privacy/"
        }],
      }, {
        title: "3.10.5 HiFive public broadcast SDK access explanation:",
        tip: "",
      }, {
        title: "①HiFive Public Broadcast SDK",
        collections: [{
          title: "Third-party entity: Chengdu HIFIVE Technology Co., Ltd."
        }, {
          title: "Collected information: IP address, device information, network environment, browsing record, search engine marketing information."
        }, {
          title: "Purpose of use: for product"
        }],
      }, {
        title: "4 Purposes and Legal Basis for Processing Personal Data:",
      }, {
        title: "4.1 The purposes for which we process your information are as follows:",
        collections: [{
          title: "(1)To provide you with services: We process your account and personal profile data, device information, usage data, location information, and information related to smart devices to provide you with the products and services you request or purchase. The legal basis for this processing is the contract signed with you according to our terms of use."
        }, {
          title: "(2)To improve our services: We process your device information, usage data, location information, and information related to smart devices to ensure the functionality and security of our products, develop and improve our products and services, analyze our operational efficiency, and prevent and track fraudulent or abusive behaviors. The legal basis for this processing is the contract signed with you according to our terms of use."
        }, {
          title: "(3)Non-marketing communication: We process your personal data to send you important information and/or other administrative information about the services, terms/conditions, and policy changes. Due to the importance of this information, you may not be able to opt out of receiving these messages. The legal basis for this processing is the contract signed with you according to our terms of use."
        }, {
          title: "(4)Marketing communication: We may process your personal data to provide you with marketing and promotional materials related to our products and services. In the above case, each email we send you will contain instructions that allow you to opt out of receiving such emails. The legal basis for this processing is based on your consent. Furthermore, if you agree to participate in our raffles, competitions, or other activities, we may use your personal data to manage these activities."
        }]
      }, {
        title: "4.2 Compliance: We process your personal data when we believe it is necessary or appropriate to:",
        collections: [{
          title: "(1) Comply with applicable laws and regulations."
        }, {
          title: "(2) Follow legal processes."
        }, {
          title: "(3) Respond to requests from public and governmental authorities."
        }, {
          title: "(4) Fulfill our terms and conditions."
        }, {
          title: "(5) Protect our operations, business, and systems."
        }, {
          title: "(6) Protect our rights, privacy, safety, or property and/or those of other users (including you)."
        }, {
          title: "(7) Seek available remedies or limit the damages that we may need to provide."
        }]
      }, {
        title: "5 Who Will We Share Your Personal Data With?",
      }, {
        title: "5.1 LinknLink only shares your personal data as you are made aware. We may share your personal data with third-party service providers who provide us with certain business-related services, such as website hosting, data analysis, payment and credit card processing, infrastructure provision, IT services, customer support services, email services, etc., to ensure they can provide services for us.",
      }, {
        title: "5.2 We disclose your personal data to customers and other business partners who directly or indirectly provide you with smart devices and/or networks and systems you use to access and use our websites and services.",
      }, {
        title: "5.3 In situations of restructuring, merger, sale, joint venture, assignment, transfer, or other disposal of all or part of our business, assets, or shares (including but not limited to any bankruptcy or similar proceedings), we disclose your personal data to affiliated companies or other third parties. In this case, you will receive explicit notification via email and/or our website about changes in ownership, new ways that are incompatible with the use of personal data, and choices regarding personal data.",
      }, {
        title: "5.4 When we believe it is necessary or appropriate, we:",
        collections: [{
          title: "(1) Comply with applicable laws and regulations."
        }, {
          title: "(2) Follow legal processes."
        }, {
          title: "(3) Respond to requests from public and governmental authorities, including those outside your country of residence."
        }, {
          title: "(4) Fulfill our terms and conditions."
        }, {
          title: "(5) Protect our operations, business, and systems."
        }, {
          title: "(6) Protect our rights, privacy, safety, or property, and/or those of other users (including you)."
        }, {
          title: "(7) Seek available remedies or limit the damages that we may need to provide. We disclose your personal data to the company's subsidiaries or affiliates for regular business activities. Except for the aforementioned third parties, we only disclose your personal data to other third parties with your consent."
        }]
      }, {
        title: "6 International Transfer of Collected Information",
      }, {
        title: "6.1 For the convenience of our operations, we may transfer, store, and process your personal data outside the jurisdiction where you live. These countries may have different data protection laws. In this case, we ensure that your information is adequately protected, either by one or more of the following: agreements under EU Standard Contractual Clauses approved according to Article 46 of the GDPR. For more information, please visit: https://ec.europa.eu/info/law/law-topic/data-protection/data-transfers-outside-eu/model-contracts-transfer-personal-data-third-countries_en. If you want to know more about our security measures, you can directly contact us through this policy.",
      }, {
        title: "6.2 If you are in the EU, all your user data is primarily stored in the EU, but to enhance the user experience of your product, our company will transfer the data you agree to upload to EU-approved whitelist countries and regions (USA, Canada, Switzerland, New Zealand) or to servers in mainland China, Japan, Russia. Although we have taken necessary security measures for your data according to Article 46 of the GDPR, there are still certain risks to data privacy protection when data is transferred to countries and regions outside the European Union. You are aware of the existence of risks and agree to the cross-EU transmission of data.",
      }, {
        title: "7 Your Rights Regarding Personal Data",
      }, {
        title: "7.1 We respect your rights and keep your personal data. You can exercise any of the following rights:",
        collections: [{
          title: "(1)Manually delete data through our products (currently limited to the LinknLink app)."
        }, {
          title: "(2)If you have any questions, please send an email to mailto:dpo@linklink-iot.com for help."
        }]
      }, {
        title: "7.2 You do not need to pay any fees, and we will respond within 30 days. If you decide to make a request to us by mail, please specify the information you wish to change, whether you wish us to delete your personal data from our database, and what restrictions you wish us to adhere to when using your personal data. Please note that for security reasons, we may ask you to verify your identity before processing your request further.",
      }, {
        title: "7.3 You can do the following:",
        collections: [{
          title: "(1)Request access to your personal data that we process; you have the right to know the situation of collected data, including data you agree to upload to the cloud."
        }, {
          title: "(2)Contact us to correct inaccurate or incomplete personal data about you."
        }, {
          title: "(3)Request deletion of your personal data and destroy data backed up in the cloud; the destruction operation will by default cancel interconnection with the Alexa/Google platform, and all cloud data will be deleted synchronously."
        }, {
          title: "(4)Request us to process your data according to your consent or your contract with us and, in the case where we process your data automatically, transfer personal data to you or a third party."
        }, {
          title: "(5)When we use your personal data based on your consent or our legitimate interests, opt-out or object to our use."
        }, {
          title: "(6)You can log out of your account. After you log out of your account, your cloud backup data will also be deleted. You have the right to manually destroy the account and all data under the account at any time."
        }]
      }, {
        title: "8 Security Measures",
      }, {
        title: "8.1 We take commercially reasonable physical, administrative, and technical safeguards to maintain the integrity and security of your personal data. LinknLink provides various security policies, effectively ensuring the safety of user and device data. In terms of device access, we use LinknLink's proprietary algorithm to ensure data isolation, access authentication, and authorized applications. In terms of data communication, we support the use of secure algorithms and transport encryption protocols, as well as business-level encrypted information transmission based on dynamic keys. In terms of data processing, we adopt strict data filtering and verification and a complete data review process. In terms of data storage, all users' confidential information will be securely encrypted and stored. If, for any reason, you believe your interaction with us is no longer secure (for example, you believe the security of your LinknLink account has been compromised), please notify us immediately by sending an email to mailto:dpo@linklink-iot.com.",
      }, {
        title: "8.2 We will occasionally improve data security measures, including but not limited to data encryption, physical measures, data authentication, etc. We will choose to notify you as appropriate.",
      }, {
        title: "8.3 We have set up a Data Protection Officer (DPO), whose contact email is mailto:dpo@linklink-iot.com.",
      }, {
        title: "8.4 If your data is violated, we will report the violation of personal data to the EU or your country's regulatory authority within 72 hours, take appropriate remedial measures as soon as possible, and report the remedial measures to you and the EU regulatory authority. If we fail to report to the regulatory authority within 72 hours, our subsequent report will explain the cause of the delay.",
      }, {
        title: "8.5 Data Retention Period: We will process your personal data for the shortest period necessary to achieve the purposes described in this policy, unless specific laws require a longer retention period. We will determine the appropriate retention period based on the quantity, nature, and sensitivity of personal data, after which we will destroy your personal data. If we cannot destroy data for technical reasons, we will take appropriate measures to prevent your personal data from being further used.",
        tip: ""
      }, {
        title: "9 Order Management and Payment",
        tip: "",
      }, {
        title: "9.1 When you purchase goods/services, we need to collect some or all of the following personal information based on the type of goods/services: your consignee information, transaction goods/services information, order number, order time, order amount. We collect this information to help you successfully complete the purchase of goods/services, ensure the safety of your transaction, query order information, provide customer service, etc. At the same time, to help you understand, query and manage order information, we will collect your order information generated during your use of our services to display to you and facilitate your order management.",
        tip: "",
      }, {
        title: "9.2 For order payment and to ensure transaction safety, we need to collect your transaction amount, order time, order merchant, order number, payment method, payment account number, and payment status information, and share some or all of the above information with payment institutions (such as WeChat, Alipay, banks, and other financial institutions) through secure means. At the same time, if you use facial/fingerprint login and/or payment function in our products and/or services, you need to enter facial or fingerprint information in advance on your local device and complete information verification on your device during service usage. We need to use your Face ID/Touch ID permission (biometric authentication permission) to receive the verification result, but we will not collect your facial or fingerprint information. If you have not enabled this permission, you will not be able to use the aforementioned services, but this does not affect your choice of other login or payment methods.",
        tip: "",
      }, {
        title: "10 Policy Change Statement",
        tip: "We may update this policy with changes in information practices. If we make any significant changes, we will notify you by email (sent to the email address specified in your account) or post a notice on the mobile application before the changes take effect. We encourage you to regularly review this page for the latest information on privacy practices."
      }, {
        title: "11 How to Contact Us",
        tip: ""
      }, {
        title: "If you have any questions about our practices or this policy, please contact us through the following methods: LinknLink PTY LTD, mailing address: 7 FairyLand Ave, Chatswood West, NSW 2067, Australia. Email: mailto:dpo@linklink-iot.com. For EU data subjects, you have the right to complain to the regulatory authority about LinknLink's data processing activities. If you have any questions or want to exercise your rights as an EU data subject, please contact our EU representative: Email: mailto:dpo@linklink-iot.com.",
        tip: "",
      }]
    }
  },
  "zh-cn": {
    backTitle: "返回",
    title: '隐私声明',
    contents: {
      title: '倍联隐私政策',
      text: "",
      step: [{
        title: "更新时间：2023年6月5日 生效时间：2023年6月5日",
        tip: "",
      },{
        title: "1.杭州倍联低碳科技有限公司（LinknLink PTY LTD）及其关联公司（以下统称为“我们”或“LinknLink”）致力于保护您的个人隐私。本隐私政策（以下称为“政策”）说明我们在您使用以下服务、产品和相关移动应用（统称为“产品”）时如何处理个人数据和保护信息隐私。",
        tip: "",
      }, {
        title: "1.1 LinknLink智能手机应用和LinknLink移动应用在本政策中，“个人数据”是指可以单独使用或与其他信息结合使用的个人识别信息。“智能设备”指由硬件制造商生产或制造的非标准计算设备，该设备具有人机（交互）界面，并可以通过无线网络传输数据，包括智能家电，智能可穿戴设备，智能空气净化设备等。“应用”指由LinknLink开发的一款移动应用，该应用使终端用户能够远程控制智能设备并连接到LinknLink的物联网（IoT）平台。",
        tip: "",
      }, {
        title: "1.2 对于由LinknLink提供支持服务的其他品牌的移动应用，由我们的客户决定通过我们的产品收集什么个人数据。我们根据客户的要求收集信息，这种信息的处理仅限于提供客户与我们约定的服务。如果您是我们的客户，并且您不愿意被我们联系，请直接联系品牌，并通知他们您的请求。",
        tip: "",
      }, {
        title: "1.3 为了向您提供我们的服务，我们将要求您提供此类服务所需的个人数据。如果您不提供个人数据，我们将无法向您提供我们的产品或服务。",
        tip: "",
      }, {
        title: "2.关于您主动提供给我们的信息",
        tip: "",
      }, {
        title: "账户或个人资料数据：当您在我们这里注册账户时，我们可能会收集您的名字和联系方式，如您的电子邮件地址，电话号码，用户名和登录凭据。在您与我们的产品互动过程中，我们可能会进一步收集您的昵称，头像，国家代码，语言偏好或您账户中的时区信息等。  反馈：当您在我们的产品中使用反馈和建议功能时，我们将收集您主动提供的电子邮件地址，手机号和反馈内容，以便及时处理您的问题和设备故障。",
        tip: "",
      }, {
        title: "3.关于我们自动收集的信息",
        tip: "",
      }, {
        title: "3.1 账户信息：您的用户昵称，头像，手机号和电子邮件地址，Apple ID授权登录账户名，Google授权登录账户名等。",
        tip: "",
      }, {
        title: "3.2 设备信息：当您与我们的产品互动时，我们将自动收集设备信息，例如位置权限：当设备连接到网络时，Android  6.0或以上版本需要获取设备Wi-Fi信息（包括附近的Wi-Fi列表）。MAC地址，IP地址，无线连接信息，操作系统类型和版本，应用程序版本号，推送通知标识符，日志文件和移动网络信息。",
        tip: "",
      }, {
        title: "3.3 使用数据：在您与我们的网站和服务互动过程中，我们自动收集与访问，点击，下载，发送/接收消息和其他使用我们的网站和服务相关的使用数据。",
        tip: "",
      }, {
        title: "3.4 日志信息：当您使用我们的应用时，系统和异常日志可能会被上传。",
        tip: "",
      }, {
        title: "3.5 位置信息：当您使用我们的某些产品或服务时，我们可能会收集关于您的实时精确或不精确的地理位置信息，例如天气服务。",
        tip: "",
      }, {
        title: "3.6 家庭名称，家庭区域（由您手动设置），房间信息，家庭背景图片，当地电价。",
        tip: "",
      }, {
        title: "3.7 用户使用功能时通常生成的数据：场景信息，联动信息，远程控制面板信息。",
        tip: "",
      }, {
        title: "3.8 关于智能设备的信息",
        tip: "",
      }, {
        title: "3.8.1 智能设备的基本信息：当您使用与我们的产品或服务连接的智能设备时，我们可能会收集关于智能设备的基本信息，如设备名称，设备ID，在线状态，激活时间，固件版本和升级信息等。",
        tip: "",
      }, {
        title: "3.8.2 智能设备报告的信息：根据您选择连接到我们的产品或服务的不同智能设备，我们可能会收集您的智能设备报告的信息。例如，智能传感器可能会报告温度和湿度，人体感应，照明等数据。",
        tip: "",
      },{
        title: "3.8.3 媒体文件信息：在您授权存储数据访问权限后，我们将根据您的需要存储音频，视频和图片数据的文件名和文件大小，并将媒体文件提供给LinknLink应用进行播放。  （目前仅在LinknLink应用中可用）",
        tip: "",
      }, {
        title: "3.9 我们不收集关于您个人种族或民族起源，政治观点，宗教，哲学信仰，工会成员资格，个人基因识别数据，或与健康，性生活或性取向相关的数据。未经儿童监护人的许可，我们不会收集16岁以下用户的数据。如果您是16岁以下的儿童，请在使用我们的产品和服务之前获取您父母或监护人的许可。",
        tip: "",
      }, {
        title: "3.10 第三方SDK访问说明：",
        tip: "",
      }, {
        title: "3.10.1 第三方账户登录的SDK访问说明：",
        tip: "",
      }, {
        title: "①微信",
        collections: [{
          title: "第三方实体：深圳市腾讯科技有限公司"
        }, {
          title: "收集信息：设备常规信息、mac地址、ip地址"
        }, {
          title: "使用目的：用于帮助用户实现微信登录倍联App"
        }, {
          title: "收集方式：SDK直接从本机采集"
        }, {
          title: "第三方隐私政策链接：https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy"
        }],
      }, {
        title: "②Apple",
        collections: [{
          title: "第三方主体：Apple.Inc"
        }, {
          title: "收集信息：设备常规信息、mac地址、ip地址"
        }, {
          title: "使用目的：用于帮助用户实现Apple登录倍联App"
        }, {
          title: "收集方式：SDK直接从本机采集"
        }, {
          title: "第三方隐私政策链接：https://www.apple.com.cn/legal/privacy/szh/"
        }],
      }, {
        title: "③Google",
        collections: [{
          title: "第三方主体：Google LLC"
        }, {
          title: "收集信息：设备常规信息、mac地址、ip地址"
        }, {
          title: "使用目的：用于帮助用户实现Google登录倍联App"
        }, {
          title: "收集方式：SDK直接从本机采集"
        }, {
          title: "第三方隐私政策链接：https://policies.google.cn/privacy?hl=zh-CN"
        }],
      }, {
        title: "3.10.2推送通知SDK功能接入说明：",
        tip: "",
      }, {
        title: "①小米",
        collections: [{
          title: "第三方主体：小米科技有限责任公司"
        }, {
          title: "收集信息：用户id、IMEI、设备型号等常规信息"
        }, {
          title: "使用目的：用于倍联App向小米手机用户推送消息"
        }, {
          title: "收集方式：SDK直接从本机采集"
        }, {
          title: "第三方隐私政策链接：https://www.mi.com/aptitude/list?id=62"
        }],
      }, {
        title: "②华为",
        collections: [{
          title: "第三方主体：华为技术有限公司"
        }, {
          title: "收集信息：用户id、IMEI、设备型号等常规信息"
        }, {
          title: "使用目的：用于倍联App向华为手机用户推送消息"
        }, {
          title: "收集方式：SDK直接从本机采集"
        }, {
          title: "第三方隐私政策链接：https://www.huawei.com/cn/privacy-policy"
        }],
      }, {
        title: "③OPPO",
        collections: [{
          title: "第三方主体：OPPO广东移动通信有限公司"
        }, {
          title: "收集信息：用户id、IMEI、设备型号等常规信息"
        }, {
          title: "使用目的：用于倍联App向OPPO手机用户推送消息"
        }, {
          title: "收集方式：SDK直接从本机采集"
        }, {
          title: "第三方隐私政策链接：https://privacy.oppo.com/cn/policy/"
        }],
      }, {
        title: "④VIVO",
        collections: [{
          title: "第三方主体：维沃移动通信有限公司"
        }, {
          title: "收集信息：用户id、IMEI、设备型号等常规信息"
        }, {
          title: "使用目的：用于倍联App向VIVO手机用户推送消息"
        }, {
          title: "收集方式：SDK直接从本机采集"
        }, {
          title: "第三方隐私政策链接：http://www.vivo.com.cn/about-vivo/privacy-policy"
        }],
      }, {
        title: "⑤魅族",
        collections: [{
          title: "第三方主体：魅族科技有限公司"
        }, {
          title: "收集信息：用户id、IMEI、设备型号等常规信息"
        }, {
          title: "使用目的：用于倍联App向魅族手机用户推送消息"
        }, {
          title: "收集方式：SDK直接从本机采集"
        }, {
          title: "第三方隐私政策链接：https://www.meizu.com/legal.html"
        }],
      }, {
        title: "⑥支付宝支付",
        collections: [{
          title: "第三方主体：支付宝（中国）网络技术有限公司"
        }, {
          title: "收集信息：用户id、IMEI、设备型号等常规信息"
        }, {
          title: "使用目的：可帮助用户完成付款"
        }, {
          title: "隐私权政策链接：https://render.alipay.com/p/c/k2cx0tg8"
        }],
      }, {
        title: "⑦阿里云推送",
        collections: [{
          title: "第三方主体：阿里云计算有限公司"
        }, {
          title: "收集信息：设备识别信息"
        }, {
          title: "使用目的：用户id、IMEI、设备型号等常规信息"
        }, {
          title: "收集方式：SDK直接从本机采集"
        }, {
          title: "第三方隐私政策链接：https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112071754_83380.html"
        }],
      }, {
        title: "3.10.3用于App崩溃日志上报SDK接入说明：",
        tip: "",
      }, {
        title: "①Google firebase crashlytics",
        collections: [{
          title: "第三方主体：Google LLC"
        }, {
          title: "收集信息：用户id、崩溃日志、设备型号等常规信息"
        }, {
          title: "使用目的：用于倍联App崩溃日志上报"
        }, {
          title: "收集方式：SDK直接从本机采集"
        }, {
          title: "第三方隐私政策链接：https://policies.google.cn/privacy?hl=zh-CN"
        }],
      }, {
        title: "3.10.4 高德地图定位SDK接入说明：",
        tip: "",
      }, {
        title: "①高德定位SDK",
        collections: [{
          title: "第三方主体：高德软件有限公司"
        }, {
          title: "收集信息：设备信息（IP地址）、设备标识信息（IMEI）、当前应用信息、设备参数及系统信息等常规信息、位置信息（经纬度）"
        }, {
          title: "使用目的：提供定位信息，用于倍联家庭信息创建，管理设备位置"
        }, {
          title: "收集方式：SDK直接从本机采集"
        }, {
          title: "第三方隐私政策链接：https://lbs.amap.com/pages/privacy/"
        }],
      }, {
        title: "3.10.5 HiFive公播SDK接入说明：",
        tip: "",
      }, {
        title: "①HiFive公播SDK",
        collections: [{
          title: "第三方主体：成都嗨翻屋科技有限公司"
        }, {
          title: "收集信息：IP地址、设备信息、网络环境、浏览记录、搜索引擎营销信息"
        }, {
          title: "使用目的：用于歌曲展示、播放"
        }, {
          title: "收集方式：SDK直接从本机采集"
        }],
      }, {
        title: "4.处理个人数据的目的和法律依据",
      }, {
        title: "4.1我们处理您信息的目的如下：",
        collections: [{
          title: "（1）为您提供服务：我们处理您的账户和个人资料数据、设备信息、使用数据、位置信息以及智能设备相关信息，以提供您请求或购买的产品和服务。这种处理的法律依据是根据我们的使用条款与您签订的合同。"
        }, {
          title: "（2）改进我们的服务：我们处理您的设备信息、使用数据、位置信息以及智能设备相关信息，以确保我们产品的功能和安全性，开发和改进我们的产品和服务，分析我们的运营效率，并防止和追踪欺诈或滥用行为。这种处理的法律依据是根据我们的使用条款与您签订的合同。"
        }, {
          title: "（3）非营销通信：我们处理您的个人数据，向您发送有关服务、条款/条件以及政策变更等重要信息和/或其他管理信息。由于这些信息的重要性，您可能无法选择不接收这些邮件。这种处理的法律依据是根据我们的使用条款与您签订的合同。"
        }, {
          title: "（4）营销通信：我们可能会处理您的个人数据，向您提供与我们的产品和服务相关的营销和推广资料。在上述情况下，我们发送给您的每一封电子邮件都将包含允许您选择不接收此类邮件的指示。这种处理的法律依据是基于您的同意。此外，如果您同意参加我们的抽奖、竞赛或其他活动，我们可能会使用您的个人数据来管理这些活动。"
        }]
      }, {
        title: "4.2 合规：我们认为必要或适当时，我们会处理您的个人数据：",
        collections: [{
          title: "（1）遵守适用的法律和法规。"
        }, {
          title: "（2）遵循法律程序。"
        }, {
          title: "（3）响应公共机构和政府机关的请求。"
        }, {
          title: "（4）履行我们的条款和条件。"
        }, {
          title: "（5）保护我们的运营、业务和系统。"
        }, {
          title: "（6）保护我们及/或其他用户（包括您）的权利、隐私、安全或财产。"
        }, {
          title: "（7）寻求可用的补救措施或限制我们可能需要提供的损害赔偿。"
        }]
      }, {
        title: "5.我们与谁共享您的个人数据？",
      }, {
        title: "5.1 LinknLink只按您所知道的方式分享您的个人数据。我们可能会与第三方服务提供商分享您的个人数据，这些提供商为我们提供某些与业务相关的服务，如网站托管、数据分析、支付和信用卡处理、基础设施提供、IT服务、客户支持服务、邮件服务等相似服务，以确保他们能够为我们提供服务。",
      }, {
        title: "5.2 向直接或间接为您提供智能设备和/或您用于访问和使用我们网站和服务的网络和系统的客户和其他商业伙伴披露您的个人数据。",
      }, {
        title: "5.3 在重组、合并、出售、合资、分配、转让或其他处置我们的全部或部分业务、资产或股份的情况下（包括但不限于任何破产或类似程序的情况），向附属公司或其他第三方披露您的个人数据。在这种情况下，您将通过电子邮件和/或我们的网站接收到关于所有权变更、与个人数据使用不相容的新方式以及关于个人数据的选择的明确通知。",
      }, {
        title: "5.4 当我们认为有必要或适当的情况：",
        collections: [{
          title: "（1）遵守适用的法律和法规。"
        }, {
          title: "（2）遵循法律程序。"
        }, {
          title: "（3）响应公共机构和政府机关的请求，包括那些不在您居住国的请求。"
        }, {
          title: "（4）履行我们的条款和条件。"
        }, {
          title: "（5）保护我们的运营、业务和系统。"
        }, {
          title: "（6）保护我们及/或其他用户（包括您）的权利、隐私、安全或财产。"
        }, {
          title: "（7）寻求可用的补救措施或限制我们可能需要提供的损害赔偿。将您的个人数据披露给公司的子公司或附属公司，以进行常规的商业活动。除上述第三方外，我们只会在得到您同意的情况下，向其他第三方披露您的个人数据。"
        }]
      }, {
        title: "6.所收集信息的国际转移",
      }, {
        title: "6.1为了便于我们的运营，我们可能会在您居住的管辖区以外的地方转移、存储和处理您的个人数据。这些国家可能有不同的数据保护法。在这种情况下，我们确保您的信息得到充分保护，通过以下一种或多种方式：根据GDPR第46条批准的EU标准合同条款下的协议。更多信息请访问：https://ec.europa.eu/info/law/law-topic/data-protection/data-transfers-outside-eu/model-contracts-transfer-personal-data-third-countries_en%E3%80%82%C2%A0 如果您想了解更多关于我们的安全保障措施，您可以直接通过这个政策联系我们。",
      }, {
        title: "6.2如果你在欧盟，所有你的用户数据优先保存在欧盟，但为了提高你使用的产品的体验，我们公司会将你同意上传的数据转移至欧盟认可的白名单国家和地区（美国，加拿大，瑞士，新西兰）或中国大陆，日本，俄罗斯的服务器。尽管我们已经根据GDPR第46条为你的数据采取了必要的安全措施，但当数据传输至欧洲联盟以外的国家和地区时，数据隐私保护仍存在一定的风险。对此，你已知晓风险存在并同意数据的跨欧盟传输。",
      }, {
        title: "7.您对个人数据的权利",
      }, {
        title: "7.1我们尊重您的权利并保存您的个人数据。您可以行使以下任何权利：",
        collections: [{
          title: "(1)通过我们的产品手动删除数据（目前限于LinknLink应用程序）。"
        }, {
          title: "(2)如果您有任何问题，请发送邮件至http://mailto:dpo@linklink-iot.com寻求帮助。"
        }]
      }, {
        title: "7.2您无需支付任何费用，我们将在30天内做出回应。如果您决定通过邮件向我们提出请求，请说明您希望更改的信息，是否希望我们从我们的数据库中删除您的个人数据，以及您希望我们在使用您的个人数据时遵守何种限制。请注意，出于安全原因，我们可能会要求您验证身份，然后再进一步处理您的请求。",
      }, {
        title: "7.3您可以做的事情：",
        collections: [{
          title: "（1）要求访问我们处理的您的个人数据，您有权知道收集的数据情况，包括您同意上传到云端的数据情况。"
        }, {
          title: "（2）联系我们纠正关于您的不准确或不完整的个人数据。"
        }, {
          title: "（3）要求删除您的个人数据；并销毁在云端备份的数据，销毁操作默认会取消与Alexa/Google平台的互联，所有云端数据同步删除。"
        }, {
          title: "（4）要求我们根据您的同意或与您的合同处理您的数据，并在我们自动处理您的数据的情况下，将个人数据转移到您或第三方。"
        }, {
          title: "（5）当我们根据您的同意或我们的合法利益使用您的个人数据时，选择退出或反对我们的使用。"
        }, {
          title: "（6）您可以登出您的账户。在您退出账户后，您的云备份数据将同时被删除。您有权随时手动销毁账户及账户下所有数据。"
        }]
      }, {
        title: "8.安全措施",
      }, {
        title: "8.1我们采取商业上合理的物理、行政和技术保障措施，以保持您的个人数据的完整性和安全。LinknLink提供多种安全策略，有效确保用户和设备的数据安全。在设备访问方面，我们使用LinknLink自有算法确保数据隔离、访问身份验证和授权应用。在数据通信方面，支持使用安全算法和传输加密协议，以及基于动态密钥的业务级加密信息传输。在数据处理方面，采取严格的数据过滤和验证以及完整的数据审查过程。在数据存储方面，所有用户的机密信息将安全加密存储。如果出于任何原因，您认为与我们的互动不再安全（例如，您认为您的LinknLink账户的安全性已经受到威胁），请立即通过发送邮件至http://mailto:dpo@linklink-iot.com通知我们。",
      }, {
        title: "8.2我们将不时改进数据安全措施，包括但不限于数据加密、物理措施、数据认证等手段。我们会根据情况选择向您通知。",
      }, {
        title: "8.3我们设立了数据保护官（DPO），其联系邮件为http://mailto:dpo@linklink-iot.com。",
      }, {
        title: "8.4如果您的数据发生了违规，我们将在72小时内向欧盟或您所在国家的监管机构报告个人数据的违规情况，尽快采取适当的补救措施，并将补救措施报告给您和欧盟监管机构。如果我们未能在72小时内向监管机构报告，我们的后续报告将解释延误的原因。",
      }, {
        title: "8.5数据保留期限  我们将处理您的个人数据，以实现此政策中所述的目的所需的最短期限，除非特定法律要求更长的保留期限。我们将基于个人数据的量、性质和敏感性来确定适当的保留期限，之后我们将销毁您的个人数据。如果我们因技术原因无法销毁数据，我们将采取适当措施，防止您的个人数据被进一步使用。",
        tip: ""
      }, {
        title: "9 订单管理和支付",
        tip: "",
      }, {
        title: "9.1当您购买商品/服务时，我们需要根据商品/服务类型收集一些或所有以下的个人信息，包括：您的收货人信息，交易商品/服务信息，订单号，订单时间，订单金额。我们收集这些信息以帮助您成功完成商品/服务的购买，确保您的交易安全，查询订单信息，提供客户服务等。同时，为了帮助您了解，查询和管理订单信息，我们将收集您在使用我们的服务期间生成的订单信息以展示给您并方便您的订单管理。",
        tip: "",
      }, {
        title: "9.2支付为了完成订单支付和确保交易安全，我们需要收集您的交易金额，订单时间，订单商户，订单号，支付方式，支付账户号码和支付状态信息，并通过安全手段与支付机构（如微信、支付宝、银行和其他金融机构）分享一部分或全部上述信息。  同时，如果您在我们的产品和/或服务中使用面部/指纹登录和/或支付功能，您需要预先在本地设备上输入面部或指纹信息，并在使用服务时在您的设备上完成信息验证。我们需要使用您的面部  ID/触摸 ID权限（生物特征认证权限）来接收验证结果，但我们不会收集您的面部或指纹信息。如果您未启用此权限，您将无法使用上述服务，但这并不影响您选择其他登录或支付方式。",
        tip: "",
      }, {
        title: "10.政策变更声明",
        tip: "我们可能会随着信息实践的变化更新此政策。如果我们做出任何重大更改，我们将在更改生效前通过电子邮件（发送到您账户中指定的电子邮件地址）或在移动应用程序上发布通知。我们鼓励您定期查看此页面以获取关于隐私实践的最新信息。",
      }, {
        title: "11.如何联系我们",
        tip: "如果您对我们的实践或此政策有任何疑问，请通过以下方式与我们联系:LinknLink PTY LTD, 邮寄地址: 7 FairyLand Ave, Chatswood West, NSW 2067, Australia. 电子邮件：http://mailto:dpo@linklink-iot.com。对于欧盟数据主体，您有权向监管机构投诉LinknLink的数据处理活动。如有疑问，或行使您作为欧盟数据主体的权利，请联系我们的欧盟代表：电子邮件：http://mailto:dpo@linklink-iot.com"
      }]
    }
  },
}


//////////////////
// WEBPACK FOOTER
// ./static/js/privacy.js
// module id = 2ZS2
// module chunks = 0